<div class="global-title-bar">
  <h2 class="global-title">
  Partners
  </h2>
</div>
<div class="main-wrap">
    <div class="button-container">
      <div class="search-box">
        <div class="ui-inputgroup">
         <input pInputText  placeholder="search term here" type="text" [(ngModel)]="searchTerm">
         <span class="ui-inputgroup-addon"><i class="pi pi-search" style="line-height: 1.25;"></i></span>
        </div>
      </div>
      <div class="add-button-wrap">
        <p-selectButton [(ngModel)]="selectedOption" [options]="displayOptions" (onChange)="updateFilter($event.value)"></p-selectButton>
        <p-button label="Add School" routerLink="/management/create-school"></p-button>
      </div>
   </div> 
  <div class="table-wrap">
    <p-table selectionMode="single" [value]="filteredSchools | jsonFilter:[searchTerm, searchOption]">
      <ng-template pTemplate="header">
        <tr>
          <th id="id-head">ID</th>
          <th id="id-head">Active</th>
          <th>Name</th>
          <th>Website</th>
          <th>Phone</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-school>
        <tr [pSelectableRow]="school">
          <td>
            {{school.id}}
          </td>
          <td class="center-span">
            <span *ngIf="school.isActive">✔️</span>
          </td>
          <td>
            <a routerLink="/management/edit-school/{{school.id}}">
              {{school.name}}
            </a>
          </td>
          <td>
            <a [href]="school.siteUrl" target="_blank">
              {{school.siteUrl}}
            </a>
          </td>
          <td>
            <a (click)="callPhone(school.phoneNumber)">
              {{school.phoneNumber}}
            </a>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>